import React from 'react'
import Invoice3Container from '../../../../../Components/Applications/ECommerce/Invoices/Invoice3'

export default function Invoice3() {
    return (
        <div className='page-body'>
            <Invoice3Container />
        </div>
    )
}